/* Copyright (c) 2022 MOCA Systems, Inc. All rights reserved. */

import { Injectable } from '@angular/core';
import { DefaultLoggerService, ILoggerService } from '@touchplan/logging';

@Injectable({
	providedIn: 'root',
})
export class LoggerServiceFactory {
	constructor() {}

	public static provide(context: string) {
		return {
			provide: DefaultLoggerService,
			useFactory: () => LoggerServiceFactory.create(context),
		};
	}

	public static create(context: string): ILoggerService {
		const logger = new DefaultLoggerService();
		logger.setContext(context);

		// Eventually, add a transport to log things into firebase like so:
		// logger.addTransport(new FirebaseLogTransport());
		return logger;
	}
}
